import {Column} from './column';
import {BaseFormModel} from '../base-form-model';

export class Sort extends BaseFormModel<Sort> {
    id: number;
    column: Column;
    sortDirection: string;

    public constructor(jsonInput: any) {
        super(jsonInput);
        Object.assign(this, jsonInput);

        this.column = !!this.column ? new Column(this.column) : null;
    }
}
